import { useRef, useState } from "react";
import TableHeader from '../../shared/table/TableHeader'
import CustomTable from '../../shared/table/CustomTable'
import { Grid, Tooltip, Box , Modal } from "@mui/material";
//import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import {GetSubscriberByGroup  ,removeCustomerFromGRoup } from '../state/alertActions'
import RandomlyColoredAvatar from "../../Layout/RandomlyColoredAvatar";
import ModalAlerts from '../../shared/DeleteModal'
const columnDefaults = {
  sortable: false,
  flex: 1,
  filterable: true,
  minWidth: 200,
};



/**
 * Required:
 
1 is message genderated 
2  is message pending
0 is message failed
   */

const defaultColumns = [
  {
    ...columnDefaults,
    field: "id",
    headerName: "ID",
    sortable:true,
    
  },
   {
    ...columnDefaults,
    field: "name",
    headerName: "Customer Name",
     renderCell:(params) => (
      <Tooltip title={params.value}>
      
      <Box display={"flex"} gap="8px" className="table-cell-trucate">
      <RandomlyColoredAvatar name={`${params.value}`} size={25} />
        {params.value}
        </Box>
    </Tooltip>
  ), 
    sortable: true,
   
  },
 

  {
    ...columnDefaults,
    field: "email",
    headerName: "Email",
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span className="table-cell-trucate">{params.value}</span>
      </Tooltip>
    ),
    sortable: true,
  },

  {
    ...columnDefaults,
    field: "account",
    headerName: "Account No.",
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span className="table-cell-trucate">{params.value}</span>
      </Tooltip>
    ),
    sortable: true,
  },


];

const allColumns = [
  ...defaultColumns,
  {
    ...columnDefaults,
    field: "phoneNumber",
    headerName: "Phone Number",
    filterable:false
  },
];

const persistColumns = (columns) => {
  localStorage.setItem(
    "CustomersColumnsGroup",
    JSON.stringify(columns.map((c) => c.field))
  );
  };

  const loadPersistentColumns = () => {
    const persistentColumns = JSON.parse(
      localStorage.getItem("CustomersColumnsGroup")
    );
    if (persistentColumns) {
      return allColumns
        .filter((c) => persistentColumns.includes(c.field))
        .sort(
          (a, b) =>
            persistentColumns.indexOf(a.field) -
            persistentColumns.indexOf(b.field)
        );
    }
    return defaultColumns;
  };


const CustomersGroupsList = ({data,success,error}) => {


  const {rows ,updatedAt , processing , pageSize , pageNumber , totalItems , totalPages }
   = useSelector((state) => state.CustomersGroups);
 



  

  const persistentColumns = loadPersistentColumns()
  
 

  
  const [tableRef, setTableRef] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [columns, setColumns] = useState(persistentColumns);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewRows, setViewRows] = useState([]);
  const [RemoveCustomers,setOpenRemoveCsutomers] = useState(false)
  const dispatch = useDispatch()






/*   const onBeforeGetContentResolve = useRef(null); */
  const customizationRef = useRef(null);
  const onSelectionChange = (rows) => {
    setSelectedRows(rows);
  };

  

  const handleColumnsChange = (items) => {
    setColumns([...items]);
    persistColumns(items);
  };

  const handlePaginationChange = (paginationFilter) => {
   dispatch(GetSubscriberByGroup({
    searchCriteria:data,
      pageNumber,
      pageSize,
      ...paginationFilter,
    
   },
   error
       
      )
    )
  }; 

  /* const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => {
      togglePrint((show) => !show);
      onBeforeGetContentResolve.current = resolve;
    });
  }; */


  const handleShowColumns = () => {
    setAnchorEl(customizationRef.current);
  };

  const handleColumnHide = (field) => {
    const filteredColumns = columns.filter((column) => column.field !== field);
    setColumns([...filteredColumns]);
    persistColumns(filteredColumns);
  };




  const onRowClick = (row) => {
    setViewRows([row]);
  };

  const HandleRemoveCustomers = () => {
    
    let RemoveData = {
    id:data,
    "customers":selectedRowsWithDetails.map((sub) => sub.id)
    }
dispatch(removeCustomerFromGRoup(RemoveData,success,error)).then(()=>{
  dispatch(GetSubscriberByGroup({
    searchCriteria:data,
      pageNumber,
      pageSize,
   },
   error
      )
    )

    setOpenRemoveCsutomers(false)
})

  }



/*   useEffect(() => {
    if (showPrint) onBeforeGetContentResolve.current();
  }, [showPrint, onBeforeGetContentResolve]); */

  const selectedRowsWithDetails = rows
    .filter((row, index) => selectedRows.includes(row.id))
    .map((row, index) => ({
      ...row,
      id: row.id,
        })); 

    
   /* const checkView = 
    rows.filter((row, index) => selectedRows.includes(`${row.transactionId}-${index}`))
    .map((row, index) => (row.generated)).includes(sentSuccess);  */
  return (
<>

<Grid
        container
        spacing={2}
        padding={3}
      >
        <Grid item xs={12}>
          <TableHeader
       defaultColumns={defaultColumns}
       allColumns={allColumns}
       inUseColumns={columns}
       numberOfRows={totalItems}
       numberOfSelectedRows={selectedRows.length}
       handleColumnsChange={handleColumnsChange}
       handleRemoveCustomers={() => setOpenRemoveCsutomers(true)}
       isPrint = {false}
       isRemove = {true}
       isMail = {false} 
      isActive = {false}
      isView = {false}
      isDeactive = {false}
      isAssgin={false}
       isHistory = {false}
       isReGenerate={false}
       handleViewMessages={() => {
        setViewRows(selectedRowsWithDetails);
        //setDrawer(true)
      }}
     
       handleUnselectAll={() => {
         setSelectedRows([]);
        
       }}
       {...{ anchorEl, setAnchorEl, handleShowColumns }}
          />
        </Grid>
        <Grid item xs={12} ref={(newTableRef) => setTableRef(newTableRef)}>
          <CustomTable
            {...{
              pageSize,
              pageNumber,
              totalItems,
              totalPages,
              columns,
              tableRef,
              updatedAt,
              loading: processing,
              onSelectionChange,
              selectedRows,
              onRowClick,
              handleColumnHide,
              onPaginationChange: handlePaginationChange,
            }}
            ApplayHeight = {false}
         
            rows={rows.map((row, index) => ({
              ...row,
              id: row?.id,
            }))}
          />
        </Grid>
      </Grid>

  {RemoveCustomers && 
  
  <Modal
  open={RemoveCustomers}
  handleClose={() => setOpenRemoveCsutomers(false)}
>
<ModalAlerts
 title="Permenantly Remove Customers from Group"
 btnTitle="Remove Customers"
 content={
  "Are you sure you want to Remove Customers? data will no longer be restored in this Group."
}
handleCloseModal={() => setOpenRemoveCsutomers(false)}
action={HandleRemoveCustomers}
/>
</Modal>
  }



</>
  )
}

export default CustomersGroupsList